
import { SupabaseClient } from "@supabase/supabase-js";
import { RawEmailData, EmailSummaryForHook } from "./types";
import { mapRawEmailToEnhancedEmailSummary } from "./utils/emailDataMapper";
import { buildEmailQuery, applyClientSideFilters, EmailFilters } from "./services/emailFilterService";
import { getEmailFilterCounts } from "./services/emailStatsService";

export { mapRawEmailToEnhancedEmailSummary, getEmailFilterCounts };
export type { EmailFilters };

export const fetchEnhancedProcessedEmailsWithFilters = async (
  supabase: SupabaseClient, 
  filters: EmailFilters
): Promise<(EmailSummaryForHook & {
  sentimentConfidence?: number;
  emotionalTone?: string;
  responseUrgency?: string;
  relationshipHealthScore?: number;
  smartNextSteps?: any[];
  contextAnalysis?: any;
  businessRelevanceScore?: number;
  isSpam?: boolean;
  spamConfidence?: number;
  contentClassification?: any;
})[]> => {
  // Build and execute the database query
  const query = buildEmailQuery(supabase, filters);
  const { data: emails, error } = await query;

  if (error) throw error;

  // Apply client-side filters
  const filteredEmails = applyClientSideFilters(emails || [], filters);

  // Map to enhanced email summaries
  return filteredEmails.map(mapRawEmailToEnhancedEmailSummary);
};
